import { Request } from 'commons/utils/request'

export const getList = () => Request.get(Request.urls.bank.parsedTransactions)
